import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'twoDecimal',
})
export class TwoDecimalPipe implements PipeTransform {

  private numberFormat = new Intl.NumberFormat('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
  });

  transform(value: any): any {
      if (value === null || value === undefined || isNaN(value)) {
          return value;
      }
      return this.numberFormat.format(Number(value));
  }
}
